module.exports = __webpack_public_path__ + "static/media/crypto.27361208.png";